const formatDateAndTime = (inputDate: Date, humanReadable?: boolean) => {
  const formatDate =
    inputDate.getDate() < 10
      ? `0${inputDate.getDate()}`
      : `${inputDate.getDate()}`;
  const formatMonth =
    inputDate.getMonth() < 10
      ? `0${inputDate.getMonth() + 1}`
      : `${inputDate.getMonth() + 1}`;
  const formatYear = inputDate.getFullYear();
  const formatHours =
    inputDate.getHours() < 10
      ? `0${inputDate.getHours()}`
      : `${inputDate.getHours()}`;
  const formatMinutes =
    inputDate.getMinutes() < 10
      ? `0${inputDate.getMinutes()}`
      : `${inputDate.getMinutes()}`;
  if (!humanReadable) {
    const formattedDate = `${formatYear}-${formatMonth}-${formatDate}`;
    const formattedTime = `${formatHours}:${formatMinutes}`;

    return { formattedDate, formattedTime };
  }
  const formattedDate = `${formatDate}/${formatMonth}/${formatYear}`;
  const formattedTime = `${formatHours}:${formatMinutes}`;

  return { formattedDate, formattedTime };
};

export default formatDateAndTime;
